import React from 'react';
import sizes from 'react-sizes';
import { withPrefix } from 'gatsby';
import styled from 'styled-components';
import VideoPoster from './video-poster.jpg';

const HeroVideo = ({ videoTitle }) => {
  return (
    <AspectRatioWrapper
      muted
      autoPlay
      playsInline
      loop
      preload="metadata"
      poster={VideoPoster}>
      <source
        src={withPrefix(`videos/${videoTitle}_mobile.mp4`)}
        type="video/mp4"
        media="(max-width: 1024px)"
      />
      <source
        src={withPrefix(`videos/${videoTitle}_desktop.mp4`)}
        type="video/mp4"
        media="(min-width: 1024px)"
      />
    </AspectRatioWrapper>
  );
};

const AspectRatioWrapper = styled.video`
  height: 100vh;
  object-fit: cover;
  object-position: center;
  position: relative;
  width: 100vw;
`;

export default sizes(({ width }) => ({ viewportWidth: width && width }))(HeroVideo);
